import { useCourierLocale } from "@src/common/courierLocale/useCourierLocale";
import { useOrderBillableItem } from "../hooks/useOrderBillableItem";
import { billableItemAssignmentOptionLabel } from "../utils/billableItemAssignmentOptions";

export interface BillableItemPriceNoteProps {
  shipmentId?: string;
  shipmentTemplateId?: string;
}

/**
 * Explains, on the price widget, that an order absorbed into a billable item is not
 * billed to the customer at this price — the price still drives the driver's pay.
 * Renders nothing for orders with no billable item.
 */
export function BillableItemPriceNote({
  shipmentId,
  shipmentTemplateId,
}: BillableItemPriceNoteProps) {
  const { formatCurrency } = useCourierLocale();
  const { billableItem } = useOrderBillableItem({
    shipmentId,
    shipmentTemplateId,
  });

  if (!billableItem) return null;

  return (
    <div className="mb-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200">
      <span>Part of billable item </span>
      <span className="font-semibold">
        {billableItemAssignmentOptionLabel(billableItem, formatCurrency)}
      </span>
      <span>. This price is only used for driver pay calculation.</span>
    </div>
  );
}
